export const scroll_color = {
  backgroundColor: "var(--mui-palette-primary-main)",
  width: "100%",
  height: "100%"
}

